import { CookieConsentGroup } from '#base/core/enums/CookieConsentGroupEnum';
import { GtagConsent } from '#base/core/enums/GtagConsentEnum';
import type { CookieConsentCombinedType } from '#base/core/types/CookieConsentType';

/** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** **
 * LET OP!
 * Wanneer er consents worden toegevoegd, OF IN VOLGORDE WIJZIGEN, dan krijgen alle
 * gebruikers opnieuw de cookiemelding!
 ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** **/

export const cookieConsents: {
	key: CookieConsentCombinedType;
	label: string;
	description: string;
	subCookieConsents?: {
		key: GtagConsent;
		label: string;
		description: string;
		required: boolean;
	}[];
	required: boolean;
}[] = [
	{
		key: GtagConsent.FunctionalityStorage,
		label: 'Functionele cookies',
		description:
            'Deze cookies zijn noodzakelijk voor het functioneren van onze website. Ze zorgen er voor dat bepaalde functies op de website correct werken. Deze cookies kunnen niet worden uitgeschakeld.',
		required: true,
		subCookieConsents: [
			{
				key: GtagConsent.SecurityStorage,
				label: 'Beveiligingsopslag',
				description:
                    'Maakt opslag gerelateerd aan beveiliging mogelijk, zoals verificatiefuncties, preventie van bedrog en andere beveiligingsmaatregelen voor gebruikers.',
				required: true,
			},
		],
	},
	{
		key: GtagConsent.AnalyticsStorage,
		label: 'Analytische cookies',
		description:
            'Met deze cookies monitoren we onze website, de verzamelde data gebruiken wij om de website te verbeteren, zowel technisch als functioneel, zodat je altijd vindt wat je zoekt.',
		required: false,
	},
	{
		key: CookieConsentGroup.Tracking,
		label: 'Tracking cookies',
		description:
            'Met deze cookies kunnen we nauwkeuriger inzien hoe onze doelgroep er uit ziet, daarmee kunnen we relevantere informatie aan onze bezoekers tonen. De cookies kunnen persoonlijke gegevens bevatten welke gebruikt kunnen worden voor gepersonaliseerde advertenties.',
		required: false,
		subCookieConsents: [
			{
				key: GtagConsent.AdStorage,
				label: 'Ad Storage',
				description:
                    'Maakt opslag (zoals cookies) gerelateerd aan advertenties mogelijk.',
				required: false,
			},
			{
				key: GtagConsent.AdUserData,
				label: 'Ad user data',
				description:
                    'Hiermee geef je toestemming om gebruikersgegevens gerelateerd aan advertenties naar Google te sturen.',
				required: false,
			},
			{
				key: GtagConsent.AdPersonalization,
				label: 'Advertentie personalisatie',
				description:
                    'Hiermee geef je toestemming voor gepersonaliseerd adverteren.',
				required: false,
			},
			{
				key: GtagConsent.PersonalizationStorage,
				label: 'Personalisatie',
				description:
                    'Maakt opslag gerelateerd aan personalisatie mogelijk, zodat wij bepaalde pagina\'s bijvoorbeeld persoonlijk af kunnen stemmen.',
				required: false,
			},
		],
	},
];

export const cookieConsentPartners = [
	{
		label: 'Google (Analytics en Ads)',
		description:
            'Google helpt ons om inzicht in het gebruik van onze website te krijgen. Daarnaast adverteren wij met Google Ads en kunnen we je gepersonaliseerde advertenties tonen.',
		url: 'https://business.safety.google/privacy',
		categories: ['Analytische Cookies', 'Tracking Cookies'],
	},
	{
		label: 'Meta',
		description:
            'Meta helpt ons om advertenties op het Meta platform zoals Facebook en Instagram te verbeteren. We meten het gedrag op onze website waarmee we gerichter kunnen adverteren.',
		url: 'https://www.facebook.com/privacy/policy',
		categories: ['Tracking Cookies'],
	},
	{
		label: 'Microsoft Clarity',
		description:
            'Met Microsoft Clarity kunnen we inzicht krijgen in hoe onze bezoekers onze website gebruiken. Deze data gebruiken we om de website te verbeteren.',
		url: 'https://www.microsoft.com/nl-nl/privacy/privacystatement',
		categories: ['Analytische Cookies'],
	},
	{
		label: 'Sentry',
		description:
            'Sentry helpt ons om fouten op onze website te monitoren en te analyseren. Deze data gebruiken we om de website te verbeteren.',
		url: 'https://sentry.io/privacy',
		categories: ['Analytische Cookies'],
	},
];
